'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const CircularityBuyBackIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M23.0232 4.39392C21.9084 2.85559 19.9379 2 17.4576 2C17.0169 2 16.5588 2.02593 16.1008 2.08642V3.47783C16.5675 3.40869 17.0169 3.38277 17.4576 3.38277C18.8836 3.38277 20.8108 3.70253 21.8911 5.20629C22.8936 6.58906 22.8677 8.62 21.8133 10.9188C21.2602 12.1374 20.4565 13.3387 19.4626 14.4881C18.4688 15.6375 17.2675 16.7092 15.9193 17.6685C12.8426 19.855 9.43756 21.1168 6.55103 21.1168C5.12506 21.1168 3.19782 20.797 2.11754 19.3019C1.11503 17.9105 1.14096 15.8795 2.19532 13.5893C2.35088 13.235 2.54101 12.8806 2.74842 12.5263H1.16688C1.08046 12.6905 1.01132 12.8547 0.933543 13.0189C-0.328232 15.7845 -0.310947 18.2994 0.985397 20.1142C2.10025 21.6526 4.0707 22.5082 6.54239 22.5082C9.71411 22.5082 13.413 21.16 16.7144 18.8093C19.6095 16.7524 21.8652 14.1511 23.0665 11.4979C24.3282 8.73235 24.3109 6.2088 23.0146 4.40256L23.0232 4.39392Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12.2374 15.2485L7.22486 10.236L18.7277 10.2014L18.7191 8.82726L7.22486 8.85319L12.1941 3.88387L11.2176 2.90729L4.58032 9.54457L11.2608 16.2251L12.2374 15.2485Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
const VpCircularityBuyBackIcon = forwardRef(CircularityBuyBackIcon);

export { VpCircularityBuyBackIcon as default };
